module.exports = __webpack_public_path__ + "static/img/1-18.950da14.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/1-18.png
// module id = 217
// module chunks = 0